import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Navbar from "../../navbar/Navbar";
import { Link } from "react-router-dom";
import { FaArrowRight, FaEllipsisV } from "react-icons/fa";
import pngwing from "../../../Images/pngwing.jpg";
import vector from "../../../Images/Vector.png";
import {
  fetchPDEInfoAsync,
  resetpdeInfo,
  selectPDEInfo,
  selectPDEReviewStatus,
  selectUserEvaluations,
  selectUserInfo,
  updatePDEInfo,
} from "../../../features/user/userSlice";
import { fetchPDEInfo } from "../../../features/user/userAPI"; // Import the fetchPDEInfo function
import {
  resetPropertyForm,
  setInitialState,
  updatePropertyForm,
} from "../../property/inputFieldSlices/propertyInputSlice";
import {
  fetchRateListDetails,
  resetPropertyState,
  setInitialPdEId,
} from "../../property/propertySlice";
import { hideStep, resetSteps, showStep } from "../../Stepper/stepperSlice";
import {
  resetOriginalDeedModalData,
  setInitialDeedFormData,
} from "../../modal/OriginalDeedModalSlice";
import { resetSelectedRate } from "../../modal/RateListModalSlice";
import { clearAadhaarDetails } from "../../property/AadhaarDetailsSlice";
import { resetResidentialModalData } from "../../modal/modalSlices/ResidentialModalSlice";
import { resetCommercialModalData } from "../../modal/modalSlices/CommercialModalSlice";
import {
  resetPropertyEvaluationForm,
  updatePropertyEvaluationForm,
} from "../../property/inputFieldSlices/propertyEvaluationInputSlice";
import {
  resetPartyDetails,
  updatePartyDetails,
} from "../../PartyDetail/PartyDetailSlice";
import {
  resetTimeSlab,
  setAppointmentInfo,
} from "../../OnlineAppointment/OnlineAppointmentSlice";
import {
  resetProcedureType,
  setProcedureType,
} from "../../modal/modalSlices/ProcedureSlice";
import {
  setModifying,
  setProcedureMod,
  setPropertyMod,
} from "../../Modify/ModifySlice";
import { v4 as uuidv4 } from "uuid";
import { resetisMobileVerified } from "../../auth/authSlice";
import Footer from "../../../pages/Footer";
import API_BASE_URL, { Report_url } from "../../BaseURL/baseURL";
import {
  resetUploadDoc,
  setUploadDetails,
} from "../../uploadDocument/UploadDocumentSlice";

function Dashboard() {
  const [showDropdowns, setShowDropdowns] = useState([]); // State to manage dropdown visibility for each row
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);
  const userInfo = useSelector(selectUserInfo);
  const evaluations = useSelector(selectUserEvaluations);
  const navigate = useNavigate(); // Initialize useNavigate
  const dispatch = useDispatch();
  const pdeInfo = useSelector(selectPDEInfo);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredEvaluations, setFilteredEvaluations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const pdeReviewStatus = useSelector(selectPDEReviewStatus);

  const hideRemarkAndEdit = pdeReviewStatus.some(
    (s) => s.statusName?.toLowerCase() === "accepted"
  );
  // Function to toggle the dropdown visibility for a specific row
  const toggleDropdown = (index) => {
    const updatedDropdowns = [...showDropdowns];
    updatedDropdowns[index] = !updatedDropdowns[index];
    setShowDropdowns(updatedDropdowns);
    setActiveDropdownIndex(activeDropdownIndex === index ? null : index);
  };

  const handleStartNewRegistration = () => {
    dispatch(setModifying(false));
    dispatch(setPropertyMod(false));
    dispatch(setProcedureMod(false));
    dispatch(resetPropertyForm());
    dispatch(resetPropertyState());
    dispatch(resetSteps());
    dispatch(resetSelectedRate());
    dispatch(resetOriginalDeedModalData());
    dispatch(resetPropertyEvaluationForm());
    dispatch(clearAadhaarDetails());
    dispatch(resetResidentialModalData());
    dispatch(resetCommercialModalData());
    dispatch(resetPartyDetails());
    dispatch(resetpdeInfo());
    dispatch(resetTimeSlab());
    dispatch(resetProcedureType());
    dispatch(resetisMobileVerified());
    dispatch(resetUploadDoc());
    sessionStorage.removeItem("datatableEntries");
    sessionStorage.removeItem("datatableEntries2");
    sessionStorage.removeItem("datatableEntriesWitness");

    // window.localStorage.removeItem("propertyEvalFormData");
    window.sessionStorage.removeItem("propertyEvalFormData");
  };

  // Filter evaluations based on date range and search parameter
  useEffect(() => {
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999);

      const filtered = evaluations.filter((evaluation) => {
        const entryDate = new Date(evaluation.entryDate);
        const matchesDate = entryDate >= from && entryDate <= to;
        const searchLower = searchQuery.toLowerCase();

        const matchesSearch =
          (evaluation.pdE_ID &&
            String(evaluation.pdE_ID).includes(searchQuery)) ||
          (evaluation.deedName2 &&
            evaluation.deedName2.toLowerCase().includes(searchLower)) ||
          (evaluation.deedName &&
            evaluation.deedName.toLowerCase().includes(searchLower)) ||
          (evaluation.location &&
            evaluation.location.toLowerCase().includes(searchLower));

        return matchesDate && matchesSearch;
      });

      setFilteredEvaluations(filtered);
    } else {
      const searchLower = searchQuery.toLowerCase();

      const filtered = evaluations.filter(
        (evaluation) =>
          (evaluation.pdE_ID &&
            String(evaluation.pdE_ID).includes(searchQuery)) ||
          (evaluation.deedName2 &&
            evaluation.deedName2.toLowerCase().includes(searchLower)) ||
          (evaluation.deedName &&
            evaluation.deedName.toLowerCase().includes(searchLower)) ||
          (evaluation.location &&
            evaluation.location.toLowerCase().includes(searchLower))
      );

      setFilteredEvaluations(filtered);
    }
  }, [fromDate, toDate, evaluations, searchQuery]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredEvaluations.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const totalPages = Math.ceil(filteredEvaluations.length / rowsPerPage);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the clicked element is outside the dropdown
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        activeDropdownIndex !== null
      ) {
        setActiveDropdownIndex(null); // Close the dropdown
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeDropdownIndex]);

  const handlePdf = async (PDE_ID) => {
    try {
      // 1. Call Encrypt API with PDE_ID
      const encryptResponse = await fetch(
        `${API_BASE_URL}/User/Encrypt?plainText=${PDE_ID}`
      );

      if (!encryptResponse.ok) {
        throw new Error("Failed to encrypt PDE_ID");
      }

      const encryptedText = await encryptResponse.text(); // or .json() if API returns JSON

      // 2. Construct PDF URL with encrypted PDE_ID
      const pdfUrl = `${Report_url}?PDE_ID=${encodeURIComponent(
        encryptedText
      )}`;

      // 3. Open in new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error encrypting PDE_ID:", error);
      alert("Unable to open PDF. Please try again.");
    }
  };

  // const hydratePDE = async (PDE_ID, dispatch) => {
  //   // 1) fetch the full PDE info
  //   const pdeInfo = await fetchPDEInfo(PDE_ID);
  //   const data = pdeInfo.pdeData[0];
  //   const procedureType = data.appointment_Type;
  //   const appointmentStatus = pdeInfo?.appointmentStatus?.[0]?.modifyFlag;

  //   // 2) core “mode” flags
  //   dispatch(setModifying(true));
  //   dispatch(setPropertyMod(true));
  //   if (["V", "VI", "P", "PH"].includes(procedureType)) {
  //     dispatch(setProcedureMod(true));
  //   }

  //   // 3) bootstrap all of your slices
  //   dispatch(setInitialPdEId(data.pdE_ID));
  //   dispatch(setInitialState(data));
  //   dispatch(setInitialDeedFormData(data));
  //   dispatch(setProcedureType(procedureType));
  //   dispatch(updatePropertyForm(data));
  //   dispatch(resetSteps());
  //   dispatch(updatePDEInfo(pdeInfo));
  //   dispatch(updatePropertyEvaluationForm());

  //   // 4) partyDetails → sessionStorage + slice
  //   if (pdeInfo.partyDetails.length > 0) {
  //     const party = pdeInfo.partyDetails[0];
  //     dispatch(
  //       updatePartyDetails({
  //         savefirstparty: party.savefirstparty,
  //         savesecondparty: party.savesecondparty,
  //         savewitness: party.savewitness,
  //       })
  //     );

  //     const normalize = (e) => ({
  //       ...e,
  //       POADate: e.poaDate,
  //       POAYear: e.poaYear,
  //       Reg_Code: e.reg_Code,
  //       Registration_For: e.registration_For,
  //       Office: e.office,
  //       DocumentNo: e.documentNo,
  //     });
  //     const addUUID = (arr) =>
  //       arr.map((e) => ({ ...normalize(e), id: uuidv4() }));

  //     sessionStorage.setItem(
  //       "datatableEntries",
  //       JSON.stringify(addUUID(party.savefirstparty))
  //     );
  //     sessionStorage.setItem(
  //       "datatableEntries2",
  //       JSON.stringify(addUUID(party.savesecondparty))
  //     );
  //     sessionStorage.setItem(
  //       "datatableEntriesWitness",
  //       JSON.stringify(addUUID(party.savewitness))
  //     );
  //   } else {
  //     // if no party details, clear out old ones
  //     dispatch(
  //       updatePartyDetails({
  //         savefirstparty: [],
  //         savesecondparty: [],
  //         savewitness: [],
  //       })
  //     );
  //     sessionStorage.removeItem("datatableEntries");
  //     sessionStorage.removeItem("datatableEntries2");
  //     sessionStorage.removeItem("datatableEntriesWitness");
  //   }

  //   // 5) hide step 5 if this PDE’s appointment was already modified
  //   if (appointmentStatus === "Y") {
  //     dispatch(hideStep({ step: 5 }));
  //   }

  //   // 6) set the upload docs slice if present
  //   if (pdeInfo.uploadDocs?.length) {
  //     dispatch(setUploadDetails(pdeInfo.uploadDocs[0]));
  //   }

  //   return pdeInfo;
  // };

  const hydratePDE = async (PDE_ID, dispatch) => {
    debugger;
    try {
      const pdeInfo = await fetchPDEInfo(PDE_ID);
      if (!pdeInfo || !pdeInfo.pdeData?.[0])
        throw new Error("Invalid PDE data");

      const data = pdeInfo.pdeData[0];
      const procedureType = data.appointment_Type;
      const appointmentStatus = pdeInfo?.appointmentStatus?.[0]?.modifyFlag;
      const PaymentStatus = pdeInfo?.paymentStatus?.[0];
      const result = PaymentStatus?.result;
      debugger;
      // 1. Set mode and base flags
      dispatch(setModifying(true));
      dispatch(setPropertyMod(true));
      if (["V", "VI", "P", "PH"].includes(procedureType)) {
        dispatch(setProcedureMod(true));
        console.log("Procedure Type:", procedureType);
      }

      // 2. Hydrate Redux state
      dispatch(setInitialPdEId(data.pdE_ID));
      dispatch(setInitialState(data));
      dispatch(setInitialDeedFormData(data));
      dispatch(setProcedureType(procedureType));
      dispatch(updatePropertyForm(data));
      dispatch(resetSteps());
      dispatch(updatePDEInfo(pdeInfo));
      dispatch(updatePropertyEvaluationForm());

      console.log("pdeInfoDash =", data);
      console.log("originalDeedDash =", data);
      console.log("PROCEDURE TYPE =", procedureType);

      // 3. Set form data into sessionStorage (preserves page, word, values)
      const {
        advance,
        Pagdi,
        dwrname,
        transvalue,
        modePayment,
        ElectricityConnection,
        exedate,
        page,
        word,
        regfeeMin,
        regfeeMax,
        regPct,
        minstamp,
        stamppct,
        maxstamp,
        leasePeriod,
        avgRent,
        mvalue,
        rfee,
        stampduty,
        landcost,
        structcost,
        selectedSRO,
      } = data;

      const formData = {
        advance,
        Pagdi,
        dwrname,
        transvalue,
        modePayment,
        ElectricityConnection,
        exedate,
        page,
        word,
        regfeeMin,
        regfeeMax,
        regPct,
        minstamp,
        stamppct,
        maxstamp,
        leasePeriod,
        avgRent,
        mvalue,
        rfee,
        stampduty,
        landcost,
        structcost,
        selectedSRO,
      };

      sessionStorage.setItem("propertyEvalFormData", JSON.stringify(formData));

      // 4. Handle partyDetails → Redux + sessionStorage
      if (pdeInfo.partyDetails.length > 0) {
        const party = pdeInfo.partyDetails[0];

        dispatch(
          updatePartyDetails({
            savefirstparty: party.savefirstparty,
            savesecondparty: party.savesecondparty,
            savewitness: party.savewitness,
          })
        );

        const normalize = (entry) => ({
          ...entry,
          POADate: entry.poaDate,
          POAYear: entry.poaYear,
          Reg_Code: entry.reg_Code,
          Registration_For: entry.registration_For,
          Office: entry.office,
          DocumentNo: entry.documentNo,
        });

        const addUUID = (arr) =>
          arr.map((entry) => ({
            ...normalize(entry),
            id: uuidv4(),
          }));

        const firstPartyEntries = addUUID(party.savefirstparty);
        const secondPartyEntries = addUUID(party.savesecondparty);
        const witnessEntries = addUUID(party.savewitness);

        sessionStorage.setItem(
          "datatableEntries",
          JSON.stringify(firstPartyEntries)
        );
        sessionStorage.setItem(
          "datatableEntries2",
          JSON.stringify(secondPartyEntries)
        );
        sessionStorage.setItem(
          "datatableEntriesWitness",
          JSON.stringify(witnessEntries)
        );

        console.log("datatableEntries:", firstPartyEntries);
        console.log("datatableEntries2:", secondPartyEntries);
        console.log("datatableEntriesWitness:", witnessEntries);
      } else {
        dispatch(
          updatePartyDetails({
            savefirstparty: [],
            savesecondparty: [],
            savewitness: [],
          })
        );
        sessionStorage.removeItem("datatableEntries");
        sessionStorage.removeItem("datatableEntries2");
        sessionStorage.removeItem("datatableEntriesWitness");
      }

      // 5. Hide step 5 if appointment was modified
      if (appointmentStatus === "Y") {
        dispatch(hideStep({ step: 5 }));
        console.log("step 5 hidden");
      }

      // 6. Set uploadDocs slice if present
      if (pdeInfo.uploadDocs?.length > 0) {
        dispatch(setUploadDetails(pdeInfo.uploadDocs[0]));
      }

      return pdeInfo;
    } catch (error) {
      console.error("Error hydrating PDE:", error);
      throw error; // Let caller handle navigation or fallback
    }
  };

  // Handlers
  const handleModifyClick = async (PDE_ID) => {
    try {
      await hydratePDE(PDE_ID, dispatch);
      navigate("/property");
    } catch (error) {
      console.error("Modify error", error);
    }
  };

  const handleRescheduleClick = async (PDE_ID) => {
    try {
      await hydratePDE(PDE_ID, dispatch);
      dispatch(setAppointmentInfo({ mode: "modify", PDE_ID }));
      dispatch(showStep({ step: 5 }));
      navigate("/OnlineAppointment");
    } catch (error) {
      console.error("Reschedule error", error);
    }
  };

  const handlePay = async (PDE_ID, isAccepted) => {
    const evaluation = evaluations.find((e) => e.pdE_ID === PDE_ID);
    if (evaluation?.status === "COMPLETE" || isAccepted) {
      try {
        await hydratePDE(PDE_ID, dispatch);
        navigate("/OnlinePayment");
      } catch (error) {
        console.error("Payment error", error);
      }
    } else {
      alert("Cannot proceed to payment: status is not Complete.");
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex min-h-screen">
        <div className="flex justify-center w-full mx-auto">
          <div className="w-full py-6 bg-white rounded-lg">
            <div className="space-y-4">
              {/* First row: Image and Text */}
              <div className="flex flex-col md:flex-row mt-3">
                {/* Blank space */}
                <div className="hidden md:block md:w-1/6"></div>

                {/* Image */}

                <div className="relative w-full md:w-2/12 flex justify-center md:justify-start">
                  <img
                    src={pngwing}
                    alt="Image"
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 md:static md:transform-none max-w-full h-auto"
                  />
                </div>

                {/* Text */}
                <div className="w-full md:w-5/12 mt-5 md:mt-0 px-4">
                  <p className="text-lg font-bold mb-0">
                    Register Your New Property in Uttarakhand
                  </p>
                  <div className="flex justify-end mt-0 mb-0">
                    <img src={vector} alt="Vector" className="me-5" />
                  </div>
                  <p className="mt-1">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s.
                  </p>
                  <div className="flex justify-start">
                    <Link
                      to="/property"
                      onClick={handleStartNewRegistration}
                      className="btn btn-primary rounded-full flex items-center bg-blue-500 text-white py-2 px-4 mt-5"
                    >
                      Start New Registration <FaArrowRight className="ml-2" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center"></div>
              <hr className="h-0.5 border-none bg-gray-400" />
            </div>

            {/* Search and Date Range */}
            <div className="px-4 py-6">
              {/* Table for Appointments */}
              <h2 className="text-xl font-semibold mb-4">My Appointments</h2>
              <div className="grid gap-2 mb-2 sm:grid-cols-5 grid-cols-3 items-center">
                <div className="block w-full relative sm:col-span-1">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                </div>
                <div className="block w-full relative sm:col-span-1">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <div className="block w-full relative sm:col-span-1">
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 text-sm">
                  <thead className="bg-gray-100 font-semibold">
                    <tr>
                      <th className="py-2 px-4 border-b">S No.</th>
                      <th className="py-2 px-4 border-b">PDE_ID</th>
                      <th className="py-2 px-4 border-b">Doc. Nature</th>

                      <th className="py-2 px-4 border-b">
                        Sub deed / doc. Title
                      </th>
                      <th className="py-2 px-4 border-b">Location</th>
                      <th className="py-2 px-4 border-b">Entry Date</th>

                      <th className="py-2 px-4 border-b">PDE Review Status</th>
                      <th className="py-2 px-4 border-b">PDE Review Remark</th>
                      <th className="py-2 px-4 border-b">Status</th>
                      <th className="py-2 px-4 border-b">Edit</th>
                      <th className="py-2 px-4 border-b">Stamp Duty</th>

                      <th className="py-2 px-4 border-b">Pre. Reg. Summary</th>
                      <th className="py-2 px-4 border-b">Appointment</th>
                      <th className="py-2 px-4 border-b">Action</th>
                    </tr>
                  </thead>

                  <tbody className="text-black text-sm text-center font-light">
                    {currentRows.map((evaluation, index) => {
                      const matchingStatuses = pdeReviewStatus.filter(
                        (status) => status.pdE_ID === evaluation.pdE_ID
                      );

                      {
                        /* const reviewStatusText = matchingStatuses
                        .map((s) => s.statusName)
                        .join(", ");
                      const reviewRemarkText = matchingStatuses
                        .map((s) => s.remark)
                        .join(" | ");
                      const isAccepted =
                        reviewStatusText.toLowerCase() === "accepted";
                      const displayRemark = isAccepted ? "—" : reviewRemarkText; */
                      }

                      const reviewStatusText = matchingStatuses
                        .map((s) => s.statusName)
                        .join(", ");

                      // join only non-null remarks
                      const reviewRemarkText = matchingStatuses
                        .map((s) => s.remark)
                        .filter(Boolean)
                        .join(" | ");

                      const isAccepted = matchingStatuses.some(
                        (s) => s.statusName.toLowerCase() === "accepted"
                      );
                      const isIncomplete = matchingStatuses.some(
                        (s) => s.statusName.toLowerCase() === "incomplete"
                      );

                      // if Accepted or Incomplete, show dash; else show actual text (or dash if empty)
                      const displayReviewStatus = isIncomplete
                        ? "—"
                        : reviewStatusText || "—";
                      const displayRemark =
                        isAccepted || isIncomplete
                          ? "—"
                          : reviewRemarkText || "—";

                      return (
                        <tr
                          key={index}
                          className="border-b border-gray-200 hover:bg-gray-100"
                        >
                          <td className="py-3 px-6 whitespace-nowrap">
                            {indexOfFirstRow + index + 1}
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.pdE_ID}
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.deedName2}
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.deedName}
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.location}
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.entryDateFormatted}
                          </td>

                          {/* <td className="py-2 px-4 border-b">
                            {reviewStatusText || "—"}
                          </td> */}
                          <td className="py-2 px-4 border-b">
                            {displayReviewStatus || "—"}
                          </td>
                          <td className="py-2 px-4 border-b">
                            <div
                              className="truncate max-w-[200px] cursor-pointer"
                              title={displayRemark}
                            >
                              {displayRemark || "—"}
                            </div>
                          </td>

                          <td className="py-2 px-4 border-b">
                            {evaluation.status}
                          </td>
                          <td className="py-2 px-4 border-b">
                            <button
                              onClick={() =>
                                handleModifyClick(evaluation?.pdE_ID)
                              }
                              disabled={isAccepted}
                              className={`focus:outline-none ${
                                isAccepted
                                  ? "text-gray-400 cursor-not-allowed"
                                  : "text-blue-500 hover:underline cursor-pointer"
                              }`}

                              // className="text-blue-500"
                            >
                              Edit
                            </button>
                          </td>
                          {/*<td className="py-2 px-4 border-b">
                            <button
                              onClick={() =>
                                handlePay(evaluation.pdE_ID, isAccepted)
                              }
                              disabled={
                                evaluation.status !== "COMPLETE" || !isAccepted
                              }
                              className={`focus:outline-none ${
                                evaluation.status === "COMPLETE" || isAccepted
                                  ? "text-blue-500 hover:underline cursor-pointer"
                                  : "text-gray-400 cursor-not-allowed"
                              }`}
                            >
                              Pay
                            </button>
                          </td>*/}
                          <td className="py-2 px-4 border-b">
                            <button
                              onClick={() =>
                                handlePay(evaluation.pdE_ID, isAccepted)
                              }
                              // enabled if accepted OR (complete && type === "P")
                              disabled={
                                !(
                                  isAccepted ||
                                  (evaluation.status === "COMPLETE" &&
                                    evaluation.appointment_Type === "P")
                                )
                              }
                              className={`focus:outline-none ${
                                isAccepted ||
                                (evaluation.status === "COMPLETE" &&
                                  evaluation.appointment_Type === "P")
                                  ? "text-blue-500 hover:underline cursor-pointer"
                                  : "text-gray-400 cursor-not-allowed"
                              }`}
                            >
                              Pay
                            </button>
                          </td>

                          <td className="py-2 px-4 border-b">
                            <Link
                              onClick={() => handlePdf(evaluation.pdE_ID)}
                              className="text-blue-500"
                            >
                              PDF
                            </Link>
                          </td>
                          <td className="py-2 px-4 border-b">
                            {evaluation.appointmentDate}
                          </td>
                          <td className="py-2 px-4 border-b text-center relative">
                            <button
                              className="focus:outline-none"
                              onClick={() => toggleDropdown(index)}
                            >
                              <FaEllipsisV />
                            </button>
                            {activeDropdownIndex === index && (
                              <div className="absolute right-0 mt-2 w-[8rem] origin-top-right bg-gray-100 border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none z-10">
                                {/* <div className="py-1 px-2 text-sm text-blue-300 font-semibold hover:bg-gray-100">
                                  <button
                                    onClick={() =>
                                      handleModifyClick(evaluation.pdE_ID)
                                    }
                                  >
                                    Modify
                                  </button>
                                </div> */}
                                <div className="py-1 px-4 text-sm text-red-300 font-semibold hover:bg-gray-100">
                                  <button
                                    onClick={() =>
                                      handleRescheduleClick(evaluation.pdE_ID)
                                    }
                                    disabled={!isAccepted}
                                  >
                                    Reschedule
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex justify-between items-center mt-4">
                <div>
                  Showing{" "}
                  {`${indexOfFirstRow + 1}-${Math.min(
                    indexOfLastRow,
                    filteredEvaluations.length
                  )} of ${filteredEvaluations.length}`}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`${
                      currentPage === 1
                        ? "bg-gray-200 text-gray-700"
                        : "bg-gray-200 text-gray-700"
                    } rounded-lg w-12 h-8 flex items-center justify-center`}
                  >
                    Prev
                  </button>
                  {Array.from(
                    { length: Math.min(totalPages, 3) },
                    (_, index) => {
                      const pageNumber = currentPage - 1 + index;
                      if (pageNumber < 1 || pageNumber > totalPages)
                        return null;
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => handlePageChange(pageNumber)}
                          className={`${
                            currentPage === pageNumber
                              ? "bg-blue-500 text-white"
                              : "bg-gray-200 text-gray-700"
                          } rounded-full w-8 h-8 flex items-center justify-center`}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                  )}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`${
                      currentPage === totalPages
                        ? "bg-gray-200 text-gray-400"
                        : "bg-gray-200 text-gray-700"
                    } rounded-lg w-12 h-8 flex items-center justify-center`}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Dashboard;
